export const UPDATE_DASHBOARD_LOADER = 'UPDATE_DASHBOARD_LOADER'
export const UPDATE_TOP10_LISTS = 'UPDATE_TOP10_LISTS'
export const UPDATE_HIGHEST_VALUES = 'UPDATE_HIGHEST_VALUES'
